import SlSearchSelect from './partial/select'
import SlSearchRadio from './partial/radio'
import SlSearchDistrict from './partial/district'
import SlSearchRange from './partial/range'
import SlSearchDate from './partial/datepicker'
import SlSearchTime from './partial/timepicker'
import './style.scss'
const isFunction = v => Object.prototype.toString.call(v) == '[object Function]' 
const isPromise = v => Object.prototype.toString.call(v) == '[object Promise]' 
const isArray = v => Array.isArray(v)

const processDict = (v) => {
  v = v.filter( i => !!i )
  const precess = (i, datas, ndatas, callback) => {
    if (i >= datas.length) {
      callback(ndatas)
    } else {
      const data = datas[i]
      ndatas[i] = data
      if( isPromise(data.values) ){
        data.values.then(resp => {
          ndatas[i].values = resp
          precess(i+1,datas,ndatas,callback)
        })
      }else if(isFunction(data.values)){
        let fn = data.values()
        if(isPromise(fn)){
          fn.then(resp => {
            ndatas[i].values = resp
            precess(i+1,datas,ndatas,callback)
          })
        }else if(isArray(fn)){
          ndatas[i].values = fn
          precess(i+1,datas,ndatas,callback)
        }
      }else{
        precess(i+1,datas,ndatas,callback)
      }
    }
  }
  return new Promise((resolve) => {
    precess(0, v, [], (nd) => {
      resolve(nd)
    })
  })
}

const innerComponents = {
  'select':SlSearchSelect,
  'radio':SlSearchRadio,
  'district':SlSearchDistrict,
  'range':SlSearchRange,
  'date':SlSearchDate,
  'time':SlSearchTime
}

const Label = {
  props:['title'],
  render(){
    const { $scopedSlots } = this
    return  <div style="display:flex;align-items:center;margin:5px 0;">
      <div style="width:80px;flex:0 0 auto;text-align:right;padding: 10px 12px 10px 0;color: rgba(30, 30, 30, .7);">{this.title}</div>
      <div style="flex: 1 1 auto;">
        { $scopedSlots.default ? $scopedSlots.default() : null }
      </div>
    </div>
  }
}

export default {
  name: 'SearchCombo',
  data() {
    return {
      results: [],
      process: false,
      quickField: null,
      quickValue: null,
      quickOptions: [],
      moreOptions: [],
      showMore: false,

      //0 未加载 1加载中 2已加载
      moreOptionsLoadedState:0,

      //缓存moreOptions
      _keepMoreNode:null,
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      default: function() {
        return {}
      }
    },
    autoSearch: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visibleResult() {
      return this.results.length > 0
    },

  },

  created() {
    this.quickField = this.option.quick.default
    this.quickOptions = this.option.quick.options
  },
  watch: {

  },
  methods: {
    initData(){

    },

    handleClick() {

    },
    handleChange(key, value, label) {
      const { results, moreOptions, autoSearch } = this
      let hit = this.results.find(i => i.key == key)
      let group = this.moreOptions.find(i => i.key == key)
      label = group.label + '：' + label
      group.value = value
      if (hit) {
        hit['value'] = value
        hit['label'] = label
      } else {
        this.results.push({ key, value, label })
      }
      this.process = false

      if (autoSearch) {
        this.onSearch()
      }
      //this.$emit('change', this.results)
    },
    handleTagRemove({key}) {
      const { results, moreOptions, autoSearch } = this

      let idx = results.findIndex(i => i.key == key)
      let group = moreOptions.find(i => i.key == key)
      console.log(results,key)

      if (idx >= 0) {
        group.value = null
        this.results.splice(idx, 1)

        if (autoSearch) {
          this.onSearch()
          // this.$emit('change', this.results)
        }
      }
    },
    //处理过程
    handleProcess() {
      this.process = true
    },

    renderOption(h, group) {
      let tag = null
      let { type, label } = group
      if (['radio', 'select', 'district', 'range', 'date', 'time'].includes(type)) {
        tag = innerComponents[type]
      }
      let props = {
        field: group.key,
        value: group.value,
        values: group.values,
        options: group.options
      }
      const child = h(tag, {
        props,
        on: {
          change: this.handleChange
        }
      })
      return <Label title={label}>
        {child}
      </Label>
    },

    renderMore() {
      const { showMore, visibleResult, results, moreOptions, renderOption , handleTagRemove } = this
      if(showMore){
        if (this.moreOptionsLoadedState == 0 && this.option.more) {
          this.moreOptionsLoadedState = 1
          processDict(this.option.more).then(resp => {
            this.moreOptionsLoadedState = 2
            this.moreOptions = resp
          })
        }
      }

      const loading = this.moreOptionsLoadedState != 2

      const defaultNode = <div v-show={showMore} class="sl-search-box-wrap" >
            <div class="slb-content">
              {
                loading ? <sl-spin style="height:200px;" loading={true}></sl-spin> : moreOptions.map( i => renderOption(h , i) )
              }
            </div>
          </div> 

      // 避免使用如下判断渲染 复杂组件将造成显示延迟
      /*
        const tagNode = showMore || visibleResul ? <div /> : null
      */
      const tagNode = <div v-show={(showMore || visibleResult)} class="slb-result">
          <Label title="筛选条件">
            {
              results.map(i => (
                <Tag name={i.key} on-on-close={() => handleTagRemove(i)} closable={true}>{i.label}</Tag>

              ))
            }
          </Label>
        </div>

      return (
        <div class={['sl-search-box',showMore ? 'active' : null]}>
          { tagNode }
          { defaultNode }
        </div>
      )
    },

    onSearch() {
      let params = {}
      for (let i of this.results) {
        params[i.key] = i.value
      }

      if (this.quickField) {
        params[this.quickField] = this.quickValue
      }
      this.$emit('search', params)
    },
    onReset() {
      this.quickValue = null
      this.results = []

      const moreOptions = this.moreOptions
      for(let i of moreOptions){
        i.value = null
      }
      this.moreOptions = moreOptions
      this.$emit('reset')
    },
    toggle() {
      this.showMore = !this.showMore
    }
  },

  render(h) {
    const { results, handleTagRemove, handleProcess, handleChange, renderOption, $scopedSlots, option, moreOptions, showMore, visibleResult, quickOptions, onSearch, renderMore } = this
    const contentNode = $scopedSlots.default ? $scopedSlots.default() : null

    // <Button type="text" on-click={this.toggle} style="margin-left: 8px">{{searchLabel}}</Button>
    //<Icon type={showMore ? 'ios-arrow-up' : 'ios-arrow-down'}/>
    // console.log('moreOptions>',moreOptions)
    const expandEl =  this.option.more.length > 0 ? (<Button type="text" on-click={this.toggle} style="margin-left: 8px">
          { showMore ? '收起' : '高级搜索' }
        </Button>) : null
    const moreNode = renderMore()

    const beforeNode = $scopedSlots.prepend ? <div style="margin-bottom:8px;margin-right:8px;">{$scopedSlots.prepend()}</div> : null
    return (
      <div style="position:reative;">
        <div class="flex" style="margin-bottom:2px;flex-wrap: wrap;">
          <div class="flex" style="flex-wrap: wrap;">
            <div style="margin-right:8px;margin-bottom:8px;">
              <Input style="min-width:350px;" v-model={this.quickValue} nativeOn-keyup={arg => arg.keyCode === 13 && onSearch() }>
                <sl-select slot="prepend" value-type="string" clearable={false} data={quickOptions} v-model={this.quickField} style="width: 100px" />
              </Input>
            </div>
            {beforeNode}
            <div style="margin-bottom:8px;">
              <Button type="primary" icon="ios-search" on-click={this.onSearch}>搜索</Button>
              <Button style="margin-left: 8px" on-click={this.onReset}>重置</Button>
              {expandEl}
            </div>
          </div>
          <div>{contentNode}</div>
        </div>
        {moreNode}
      </div>
    )
  }
}
